import API from "@/axios/api";

const state = {
    dealers: [],
    users: [],
    modules: [],
    ourLegalEntities: [],
    mappedOurLegalEntities: {},
    masters: [],
    objects: [],
    licenses: [],
};

const getters = {
    dealers: state => state.dealers,
    users: state => state.users,
    modules: state => state.modules,
    ourLegalEntities: state => state.ourLegalEntities,
    mappedOurLegalEntities: state => state.mappedOurLegalEntities,
    masters: state => state.masters,
    objects: state => state.objects,
    licenses: state => state.licenses,
}

const actions = {
    async updateDealers({commit}) {
        await API.get('dealers')
            .then((response) => {
                console.log(response.data);
                commit('updateDealers', response.data.dealers)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateUsers({commit}) {
        await API.get('users')
            .then((response) => {
                console.log(response.data);
                commit('updateUsers', response.data.users)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateModules({commit}) {
        await API.get('modules')
            .then((response) => {
                console.log(response.data);
                commit('updateModules', response.data.modules)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateOurLegalEntities({commit}) {
        await API.get('our_legal_entities')
            .then((response) => {
                console.log(response.data);
                commit('updateOurLegalEntities', response.data.ourLegalEntities)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateMappedOurLegalEntities({commit}) {
        await API.get('our_legal_entities/mapped')
            .then((response) => {
                console.log(response.data);
                commit('updateMappedOurLegalEntities', response.data.ourLegalEntities)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateMasters({commit}) {
        await API.get('masters')
            .then((response) => {
                console.log(response.data);
                commit('updateMasters', response.data.masters)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateObjects({commit}) {
        await API.get('objects')
            .then((response) => {
                console.log(response.data);
                commit('updateObjects', response.data.objects)
            })
            .catch((error) => {
                console.log(error);
            });
    },
    async updateLicenses({commit}) {
        await API.get('licenses')
            .then((response) => {
                console.log(response.data);
                commit('updateLicenses', response.data.licenses)
            })
            .catch((error) => {
                console.log(error);
            });
    },
};

const mutations = {
    updateDealers(state, dealers) {
        state.dealers = dealers;
    },
    updateUsers(state, users) {
        state.users = users;
    },
    updateModules(state, modules) {
        state.modules = modules;
    },
    updateMasters(state, masters) {
        // masters.forEach(master => master.expires = new Date(master.expires).toLocaleDateString());
        state.masters = masters;
    },
    updateObjects(state, objects) {
        state.objects = objects;
    },
    updateLicenses(state, licenses) {
        // licenses.forEach(license => {
        //     license.licExpires = new Date(license.licExpires).toLocaleDateString();
        //     license.masterExpires = new Date(license.masterExpires).toLocaleDateString();
        // })
        state.licenses = licenses;
    },
    updateOurLegalEntities(state, ourLegalEntities) {
        state.ourLegalEntities = ourLegalEntities
    },
    updateMappedOurLegalEntities(state, mappedOurLegalEntities) {
        state.mappedOurLegalEntities = mappedOurLegalEntities
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
